<template>
  <div
    :class="{
      'sticky top-0': sticky,
    }"
    class="bg-white-500 z-30 flex h-16 items-center gap-2 border-b-2 border-neutral-200 px-4 py-4 text-2xl font-bold lg:px-8"
  >
    <TButton
      v-if="showBackButton"
      type="tonal"
      color="primary"
      dense
      class="flex-none"
      @click="emit('back')"
    >
      <TIcon name="arrow_back" />
    </TButton>

    <slot />
  </div>
</template>

<script setup lang="ts">
import TButton from './Button/TButton.vue';
import TIcon from './Icon/TIcon.vue';

withDefaults(
  defineProps<{
    showBackButton?: boolean;
    sticky?: boolean;
  }>(),
  {
    showBackButton: true,
    sticky: true,
  },
);
const emit = defineEmits<{
  back: [];
}>();
</script>
